export const generateSetEditId = (element) => {
  return (state, action) => {
    state.elementEditId = action.payload;
  };
};
